module.exports = __webpack_public_path__ + "img/people1.2c59d1c3.png";